 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'
import {handleSuccessfulLogin} from '~/utils/handleSuccessfulLogin'


import handleAuthenticationRedirect from './handlers/handleAuthenticationRedirect'

const mutation = graphql`
  mutation VerifyEmailMutation(
    $verificationToken: ID!
    $invitationToken: ID!
    $isInvitation: Boolean!
  ) {
    verifyEmail(verificationToken: $verificationToken) {
      error {
        message
      }
      ...handleSuccessfulLogin_UserLogInPayload @relay(mask: false)
    }
    acceptTeamInvitation(invitationToken: $invitationToken) @include(if: $isInvitation) {
      ...AcceptTeamInvitationMutationReply @relay(mask: false)
    }
  }
`
const VerifyEmailMutation = (
  atmosphere,
  variables,
  {onError, onCompleted, history}
) => {
  return commitMutation(atmosphere, {
    mutation,
    variables: {...variables, isInvitation: !!variables.invitationToken},
    onError,
    onCompleted: (res, errors) => {
      const {acceptTeamInvitation, verifyEmail} = res
      const authToken = _nullishCoalesce(_optionalChain([acceptTeamInvitation, 'optionalAccess', _ => _.authToken]), () => ( verifyEmail.authToken))
      onCompleted({verifyEmail}, errors)
      if (authToken) {
        handleSuccessfulLogin(atmosphere, verifyEmail)
        atmosphere.setAuthToken(authToken)
        const redirectPath = '/meetings'

        handleAuthenticationRedirect(acceptTeamInvitation, {
          atmosphere,
          history,
          redirectPath
        })
      }
    }
  })
}

export default VerifyEmailMutation
